import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Building2 } from "lucide-react";
import { toast } from "sonner";

export const ConvertToBodyShopButton = ({ customerId, name }) => {
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const convert = async () => {
    if (!window.confirm(`Transformar "${name}" em Body Shop?\n\nO cliente sai da lista de clientes e os jobs dele passam a apontar para o body shop.`)) return;
    setBusy(true);
    try {
      const r = await api.post(`/master/customers/${customerId}/convert-to-body-shop`);
      const d = r.data;
      toast.success(`${d.body_shop_name} agora é Body Shop${d.reused_existing ? " (cadastro existente reaproveitado)" : ""} · ${d.jobs_linked} job(s) vinculados`);
      navigate(`/master/body-shops/${d.body_shop_id}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Falha ao converter");
      setBusy(false);
    }
  };

  return (
    <Button onClick={convert} disabled={busy} data-testid="convert-to-body-shop-btn"
      className="bg-amber-600 hover:bg-amber-500 text-white shrink-0">
      <Building2 className="w-4 h-4 mr-2" />{busy ? "Convertendo..." : "Converter em Body Shop"}
    </Button>
  );
};
